// eslint-disable-next-line no-undef
if (process.env.ENABLE_CLJS_HOT_RELOAD === "true") {
  import("cljs/metabase.util.devtools");
}
